import React, { Fragment } from "react";
import GetInTouch from '../Get In Touch/GetInTouch';
import { useSelector } from "react-redux";

function Contact(props) {
    return (
        <GetInTouch />
    )
}
export default Contact;